import type { Configuration } from '@cesdk/cesdk-js'

const baseConfig: Configuration = {
  baseURL: 'https://imgly.oneshopretail.com/assets',
  ui: {
    pageFormats: {
      Square: { width: 600, height: 600, unit: 'Pixel' },
      Portrait: { width: 1200, height: 1600, unit: 'Pixel', default: true },
      Landscape: { width: 1600, height: 1200, unit: 'Pixel' },
    },
    elements: {
      blocks: {
        // remove add/edit/delete pages
        '//ly.img.ubq/page': {
          manage: false,
          format: true,
          maxDuration: 30 * 60,
        },
      },
    },
  },
}

export { baseConfig }
